module.exports = __webpack_public_path__ + "img/line-phone.1905911a.png";